<template>
  <a-card class="register">
    <div class="headline">
      <span class="headline-lang"><language-switch /></span>
      <span class="caption">{{ $t('登录') }}</span>
    </div>
    <div class="main">
      <a-form :form="form" class="user-layout-login" ref="formLogin" id="formLogin">
        <!-- <a-tabs
        :activeKey="customActiveKey"
        :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
        @change="handleTabClick">
        <a-tab-pane key="tab1" > -->
        <a-form-item>
          <a-input
            size="large"
            v-decorator="['username', { initialValue: '', rules: validatorRules.username.rules }]"
            type="text"
            :placeholder="$t('请输入帐户名')"
          >
            <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-item>

        <a-form-item>
          <a-input
            v-decorator="['password', { initialValue: '', rules: validatorRules.password.rules }]"
            size="large"
            type="password"
            autocomplete="false"
            :placeholder="$t('密码')"
          >
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-item>

        <a-row :gutter="0">
          <a-col :span="16">
            <a-form-item>
              <a-input
                v-decorator="['inputCode', validatorRules.inputCode]"
                size="large"
                type="text"
                @change="inputCodeChange"
                :placeholder="$t('请输入验证码')"
              >
                <a-icon slot="prefix" type="smile" :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" style="text-align: right">
            <img
              v-if="requestCodeSuccess"
              style="margin-top: 2px"
              :src="randCodeImage"
              @click="handleChangeCheckCode"
            />
            <img v-else style="margin-top: 2px" src="../../assets/checkcode.png" @click="handleChangeCheckCode" />
          </a-col>
        </a-row>
        <!-- </a-tab-pane>
      </a-tabs> -->
        <a-form-item>
          <a-checkbox v-decorator="['rememberMe', { initialValue: true, valuePropName: 'checked' }]"
            >{{ $t('自动登陆') }}</a-checkbox
          >
        </a-form-item>
        <a-form-item style="margin-top: 24px">
          <a-button
            size="large"
            htmlType="submit"
            class="login-button"
            :loading="loginBtn"
            @click.stop.prevent="handleSubmit"
            :disabled="loginBtn"
            >{{ $t('确定') }}
          </a-button>
        </a-form-item>
        <div style="display: flex; justify-content: space-evenly">
          <a-popover>
            <template slot="content">
              <!-- <img style="width: 200px; height: 200px" src="@/assets/tyz.jpg" alt="" /> -->
              <img style="width: 200px; height: 200px" src="@/assets/wechatMini.jpg" alt="" />
            </template>
            <a href="#"><a-icon type="wechat" theme="filled" /> {{ $t('微信小程序') }} </a>
          </a-popover>
          <a-popover>
            <template slot="content">
              <!-- <img style="width: 200px; height: 200px" src="@/assets/jinfengwechat.jpg" alt="" /> -->
              <img style="width: 200px; height: 200px" src="@/assets/eminzhongcheng.jpg" alt="" />
            </template>
            <a href="#"><a-icon type="chrome" theme="filled" /> {{ $t('微信公众号') }}</a>
          </a-popover>
        </div>
      </a-form>
      <two-step-captcha
        v-if="requiredTwoStepCaptcha"
        :visible="stepCaptchaVisible"
        @success="stepCaptchaSuccess"
        @cancel="stepCaptchaCancel"
      ></two-step-captcha>

      <a-modal :title="$t('登录部门选择')" :width="450" :visible="departVisible" :closable="false" :maskClosable="false">
        <template slot="footer">
          <a-button type="primary" @click="departOk(false)">{{ $t('确认') }}</a-button>
        </template>

        <a-form>
          <a-form-item
            :labelCol="{ span: 4 }"
            :wrapperCol="{ span: 20 }"
            style="margin-bottom: 10px"
            :validate-status="validate_status"
          >
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t('您隶属于多部门，请选择登录部门') }}</span>
              </template>
              <a-avatar style="backgroundcolor: #87d068" icon="gold" />
            </a-tooltip>
            <a-select
              @change="departChange"
              :class="{ 'valid-error': validate_status == 'error' }"
              :placeholder="$t('请选择登录部门')"
              style="margin-left: 10px; width: 80%"
            >
              <a-icon slot="suffixIcon" type="gold" />
              <a-select-option v-for="d in departList" :key="d.id" :value="d.orgCode">
                {{ d.departName }}({{ d.orgCode }})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
    <div class="footer">
      <div class="copyright">Copyright &copy;<a href="#">{{ $t('智慧水务管理平台') }}</a></div>
    </div>
  </a-card>
</template>

<script>
//import md5 from "md5"
import api from '@/api'
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import LanguageSwitch from '@/components/tools/LanguageSwitch'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import Vue from 'vue'
import { ACCESS_TOKEN, ENCRYPTED_STRING } from '@/store/mutation-types'
import { putAction, postAction, getAction } from '@/api/manage'
import { encryption, getEncryptedString } from '@/utils/encryption/aesEncrypt'
import store from '@/store/'
import { USER_INFO } from '@/store/mutation-types'

export default {
  components: {
    TwoStepCaptcha,
    LanguageSwitch,
  },
  data() {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      encryptedString: {
        key: '',
        iv: '',
      },
      state: {
        time: 60,
        smsSendBtn: false,
      },
      validatorRules: {
        username: { rules: [{ required: true, message: this.$t('请输入用户名!') }, { validator: this.handleUsernameOrEmail }] },
        password: { rules: [{ required: true, message: this.$t('请输入密码!'), validator: 'click' }] },
        captcha: { rule: [{ required: true, message: this.$t('请输入验证码!') }] },
        inputCode: { rules: [{ required: true, message: this.$t('请输入验证码!') }] },
      },
      verifiedCode: '',
      inputCodeContent: '',
      inputCodeNull: true,

      departList: [],
      departVisible: false,
      departSelected: '',
      currentUsername: '',
      validate_status: '',
      currdatetime: '',
      randCodeImage: '',
      requestCodeSuccess: false,
    }
  },
  created() {
    this.currdatetime = new Date().getTime()
    Vue.ls.remove(ACCESS_TOKEN)
    this.getRouterData()
    this.handleChangeCheckCode()
    // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
    //this.getEncrypte();
    // update-end- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
  },
  methods: {
    ...mapActions(['Login', 'Logout', 'PhoneLogin']),
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        this.loginType = 0
      } else {
        this.loginType = 1
      }
      callback()
    },
    handleTabClick(key) {
      this.customActiveKey = key
      // this.form.resetFields()
    },
    handleSubmit() {
      let that = this
      let loginParams = {}
      that.loginBtn = true
      // 使用账户密码登陆
      if (that.customActiveKey === 'tab1') {
        that.form.validateFields(
          ['username', 'password', 'inputCode', 'rememberMe'],
          { force: true },
          (err, values) => {
            if (!err) {
              loginParams.username = values.username
              // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
              //loginParams.password = md5(values.password)
              //loginParams.password = encryption(values.password,that.encryptedString.key,that.encryptedString.iv)
              loginParams.password = values.password
              loginParams.remember_me = values.rememberMe
              // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
              loginParams.captcha = that.inputCodeContent
              loginParams.checkKey = that.currdatetime
              that
                .Login(loginParams)
                .then(res => {
                  Vue.ls.set('userRoleCodes', res.result.userRoleCodes)
                  this.departConfirm(res)
                  // 获取GIS 拓扑结构 存储到 前端缓存
                  this.getGisTopologyData()
                })
                .catch(err => {
                  that.requestFailed(err)
                })
            } else {
              that.loginBtn = false
            }
          }
        )
        // 使用手机号登陆
      }
    },
    stepCaptchaSuccess() {
      this.loginSuccess()
    },
    stepCaptchaCancel() {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    handleChangeCheckCode() {
      this.currdatetime = new Date().getTime()
      getAction(`/sys/randomImage/${this.currdatetime}`)
        .then(res => {
          if (res.success) {
            this.randCodeImage = res.result
            this.requestCodeSuccess = true
          } else {
            this.$message.error(res.message)
            this.requestCodeSuccess = false
          }
        })
        .catch(() => {
          this.requestCodeSuccess = false
        })
    },
    loginSuccess(res) {
      if (res) {
        this.departSelected = res.userInfo.orgCode
        this.departOk(true)
      }
      // update-begin- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      // this.loginBtn = false
      // update-end- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      //this.$router.push({ path: "/dashboard/analysis" })
      this.$router.push({ path: '/sysHome' })
      this.$notification.success({
        message: this.$t('欢迎'),
        description: `${timeFix()}，${this.$t('欢迎回来')}`,
      })
    },
    cmsFailed(err) {
      this.$notification['error']({
        message: this.$t('登录失败'),
        description: err,
        duration: 4,
      })
    },
    requestFailed(err) {
      this.$notification['error']({
        message: this.$t('登录失败'),
        description: ((err.response || {}).data || {}).message || err.message || this.$t('请求出现错误，请稍后再试'),
        duration: 4,
      })
      // 登录失败更新验证码
      this.handleChangeCheckCode()
      this.loginBtn = false
    },
    validateInputCode(rule, value, callback) {
      if (!value || this.verifiedCode == this.inputCodeContent) {
        callback()
      } else {
        callback(this.$t('您输入的验证码不正确!'))
      }
    },
    inputCodeChange(e) {
      this.inputCodeContent = e.target.value
    },
    departConfirm(res) {
      if (res.success) {
        let multi_depart = res.result.multi_depart
        //0:无部门 1:一个部门 2:多个部门
        if (multi_depart == 0) {
          this.loginSuccess(res.result)
          this.$notification.warn({
            message: this.$t('提示'),
            description: this.$t('您尚未归属部门,请确认账号信息'),
            duration: 3,
          })
        } else if (multi_depart == 2) {
          this.departVisible = true
          this.currentUsername = this.form.getFieldValue('username')
          this.departList = res.result.departs
        } else {
          this.loginSuccess(res.result)
        }
      } else {
        this.requestFailed(res)
        this.Logout()
      }
    },
    departOk(bool) {
      if (!this.departSelected) {
        this.validate_status = 'error'
        return false
      }
      let obj = {
        orgCode: this.departSelected,
        username: this.form.getFieldValue('username'),
      }
      putAction('/sys/selectDepart', obj).then(res => {
        if (res.success) {
          const userInfo = res.result.userInfo
          Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
          store.commit('SET_INFO', userInfo)
          //console.log("---切换组织机构---userInfo-------",store.getters.userInfo.orgCode);
          this.departClear()
          if (!bool) {
            this.loginSuccess()
          }
        } else {
          this.requestFailed(res)
          this.Logout().then(() => {
            this.departClear()
          })
        }
      })
    },
    departClear() {
      this.departList = []
      this.departSelected = ''
      this.currentUsername = ''
      this.departVisible = false
      this.validate_status = ''
    },
    departChange(value) {
      this.validate_status = 'success'
      this.departSelected = value
    },
    getRouterData() {
      this.$nextTick(() => {
        if (this.$route.params.username) {
          this.form.setFieldsValue({
            username: this.$route.params.username,
          })
        }
      })
    },
    //获取密码加密规则
    getEncrypte() {
      var encryptedString = Vue.ls.get(ENCRYPTED_STRING)
      if (encryptedString === null) {
        getEncryptedString().then(data => {
          this.encryptedString = data
        })
      } else {
        this.encryptedString = encryptedString
      }
    },
    getGisTopologyData() {
      getAction('jeecg-gis/topology/topology/getUsedTopology').then(res => {
        if (res.success) {
          const EXPIRATION_24H = 24 * 60 * 60 * 1000 // 86400000毫秒
          Vue.ls.set('GIS_TOPOLOGY_DATA', res.result, EXPIRATION_24H)
          // 清除缓存 Vue.ls.remove('GIS_TOPOLOGY_DATA');
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.footer {
  position: absolute;
  width: 100%;
  bottom: 20px;
  padding: 0 16px;
  margin: 10px 0 10px;
  margin-left: 20px;
  // text-align: center;
  .links {
    margin-bottom: 8px;
    font-size: 14px;
    a {
      color: rgba(0, 0, 0, 0.45);
      transition: all 0.3s;
      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
.register {
  border-radius: 10px;
  width: 100%;
  margin-bottom: 30px;
  box-shadow: 0px 0px 20px 0px rgba(60, 96, 128, 0.2);
}
.register /deep/ .ant-card-body {
  border-radius: 10px;
  padding-top: 80px;
  padding-bottom: 80px;
}
.register /deep/ .ant-card-body .ant-input-lg {
  height: 60px;
}
.headline {
  height: 70px;
  margin: 0px 0px 40px 0px;
  text-align: center;
  .headline-lang {
    float: right;
    cursor: pointer;
  }
}
.caption {
  font-weight: 400;
  font-size: 60px;
  color: #1a212f;
}
.user-layout-login {
  label {
    font-size: 14px;
  }
  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }
  .forge-password {
    font-size: 14px;
  }
  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 56px;
    width: 100%;
    border-radius: 4px;
    background: rgba(26, 146, 255, 1);
    color: #fff;
    border-width: 0;
    &:hover {
      color: #fff;
      background: rgba(2, 31, 94, 0.8);
    }
  }
  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;
    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;
      &:hover {
        color: #1890ff;
      }
    }
    .register {
      float: right;
    }
  }
}
</style>
<style>
.valid-error .ant-select-selection__placeholder {
  color: #f5222d;
}
</style>
